import { NgModule } from '@angular/core';
import { FormComponent } from './form.component';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { DelonFormModule } from '@delon/form';
import { DelonABCModule } from '@delon/abc';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DelonACLModule } from '@delon/acl';
import { LcDateComponent } from './lc/lc-date/lc-date.component';
import { LcDateTimeComponent } from './lc/lc-date-time/lc-date-time.component';
import { LcDictSelectComponent } from './lc/lc-dict-select/lc-dict-select.component';
import { LcEditFormComponent } from './lc/lc-edit-form/lc-edit-form.component';
import { LcImportFormComponent } from './lc/lc-import-form/lc-import-form.component';
import { LcSelectComponent } from './lc/lc-select/lc-select.component';
import { LcWindowSingleComponent } from './lc/lc-window-single/lc-window-single.component';
import { LcGridFormComponent } from './lc/lc-grid-form/lc-grid-form.component';
import { LcUploadImgComponent } from './lc/lc-upload-img/lc-upload-img.component';
import { LcViewImageComponent } from './lc/lc-view-image/lc-view-image.component';
import { LcCropperImgEditorComponent } from './lc/lc-cropper-img-view/lc-editor/lc-cropper-imgeditor.component';
import { LcCropperImgLoaderComponent } from './lc/lc-cropper-img-view/lc-loader/lc-cropper-img-loader.component';
import { LcCropperImgNavbarComponent } from './lc/lc-cropper-img-view/lc-navbar/lc-cropper-img-navbar.component';
import { LcCropperImgViewComponent } from './lc/lc-cropper-img-view/lc-cropper-img-view.component';
import { LcDetailFormComponent } from './lc/lc-detail-form/lc-detail-form.component';
import {LcUploadFileComponent} from "./lc/lc-upload-file/lc-upload-file.component";
const modules=[
  CommonModule,
  NgZorroAntdModule,
  DelonFormModule,
  DelonABCModule,
  DelonACLModule,
  FormsModule,
  ReactiveFormsModule,
];
const  components=[
  FormComponent,
  LcDateTimeComponent,
  LcDateComponent,
  LcDictSelectComponent,
  LcEditFormComponent,
  LcImportFormComponent,
  LcSelectComponent,
  LcGridFormComponent,
  LcWindowSingleComponent,
  LcUploadImgComponent,
  LcUploadFileComponent,
  LcViewImageComponent,
  LcCropperImgEditorComponent,
  LcCropperImgLoaderComponent,
  LcCropperImgNavbarComponent,
  LcCropperImgViewComponent,
  LcDetailFormComponent
];
@NgModule({
  declarations: [...components],
  imports: [
    ...modules
  ],
  exports: [...components]
})
export class FormModule { }
